import { SvgProps } from "../../types";

const Clock = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 19 19"
    {...props}
  >
    <path
      fill={props.fill ? props.fill : "#1064ED"}
      d="m12.446 13.73 1.26-1.26-3.33-3.33V5h-1.8v4.86l3.87 3.87Zm-2.97 4.77a8.764 8.764 0 0 1-3.51-.709 9.089 9.089 0 0 1-2.858-1.924 9.089 9.089 0 0 1-1.924-2.857A8.764 8.764 0 0 1 .476 9.5c0-1.245.236-2.415.708-3.51a9.089 9.089 0 0 1 1.924-2.858A9.089 9.089 0 0 1 5.966 1.21 8.764 8.764 0 0 1 9.476.5c1.245 0 2.415.236 3.51.709a9.089 9.089 0 0 1 2.857 1.923 9.089 9.089 0 0 1 1.924 2.858 8.764 8.764 0 0 1 .709 3.51 8.764 8.764 0 0 1-.71 3.51 9.089 9.089 0 0 1-1.923 2.857 9.089 9.089 0 0 1-2.857 1.924 8.764 8.764 0 0 1-3.51.709Zm0-1.8c1.995 0 3.693-.701 5.096-2.104 1.402-1.402 2.104-3.101 2.104-5.096s-.702-3.694-2.104-5.096C13.169 3 11.47 2.3 9.476 2.3s-3.694.701-5.097 2.104C2.977 5.806 2.276 7.505 2.276 9.5s.7 3.694 2.103 5.096C5.782 16 7.481 16.7 9.476 16.7Z"
    />
  </svg>
);
export default Clock;
